import Registry from './registry.js';
import Language from './language.js';
import locale_de from '../locale/de.js';
import locale_en from '../locale/en.js';
import { DomUtility } from '../utilities/domutility.js';

const bootstrap = window.bootstrap;

export default class Core {
    public Config: Registry;
    public Registry: Registry;
    public Lang: Language;
	constructor() {
        const self = this;
		this.Config = new Registry();
		this.Registry = new Registry();

        let lang: string = document.querySelector('html')?.getAttribute('lang') ?? '';

        const typo3 = (window as any).TYPO3 ?? null;

        if(typo3) {
            if(typo3.lang && typo3.lang != '') {
                lang = typo3.lang;
            }
            if(typo3.settings && typo3.settings.TS) {
                for(const key in typo3.settings.TS) {
                    this.Config.set(key, typo3.settings.TS[key], false);
                }
            }
        }

        self.Lang = new Language({lang: lang });
        self.Lang.addBundles(locale_de);
        self.Lang.addBundles(locale_en);
	}

	async imagesLoaded(el: HTMLElement, timeout: number = 2000): Promise<string[]> {
        return DomUtility.imagesLoaded(el, timeout);
	}

	async imageLoaded(el: HTMLImageElement, timeout: number = 2000): Promise<string> {
        return DomUtility.imageLoaded(el, timeout);
	}

	errorHandler(message: string, title: string, type: string, containerEl: string|HTMLElement) {
		if(typeof(type) == 'undefined') {
			type = 'warning';
		}
        console.trace();
		message = this.Lang.translate(message, null, message);
		if(typeof(containerEl) == 'undefined' || containerEl == '') {
			const toastEl: HTMLElement = document.createElement('div');
			toastEl.setAttribute('class', 'toast border-0 position-fixed placeto-tc p-0 alert alert-'+type);
			toastEl.setAttribute('role', 'alert');
			toastEl.setAttribute('aria-live', 'assertive');
			toastEl.setAttribute('aria-atomic', 'true');
			toastEl.style.zIndex = '100';

			if(title) {
				toastEl.innerHTML += `
					<div class="toast-header text-white bg-${type}">
						<strong class="mr-auto">${title}</strong>
						<button type="button" class="ml-2 close text-white" data-dismiss="toast" aria-label="Close"><span aria-hidden="true">&times;</span></button>
					</div>
				`;
			}
			toastEl.innerHTML += `
				<div class="toast-body">${message}</div>
			`;

			document.querySelector<HTMLBodyElement>('body')?.appendChild(toastEl);

			const toast = bootstrap.Toast.getOrCreateInstance(toastEl, {
				autohide: false,
				delay: 15000
			});

			toast.show();
		} else {
			const alertEl = document.createElement('div');
			alertEl.setAttribute('class', 'alert alert-'+type);
			alertEl.innerHTML = message;
			document.querySelector<HTMLBodyElement>('body')?.appendChild(alertEl);
		}
	}
}
